module.exports = __webpack_public_path__ + "static/img/plem13.25472f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/plem13.png
// module id = Zy5j
// module chunks = 1